export default {
  apiKey: 'AIzaSyBBdjA1Q6FtnXSeSZhPXq2AQwIatHDIikU',
  authDomain: 'resilient-app-av.firebaseapp.com',
  projectId: 'resilient-app-av',
  storageBucket: 'resilient-app-av.appspot.com',
  messagingSenderId: '941638807546',
  appId: '1:941638807546:web:85c6c6428d423fc249be43',
  measurementId: 'G-R59GPNPDLP',
};
